import PlaceIcon from '@mui/icons-material/Place';
import React from "react";
import { Link } from "react-router-dom";

function PopularCityCard({ city, stateId, state2, key, language }) {
  const lang = language || "";

  const { image, name, ar_name, state, _id, slug } = city;
  const countryName = state2?.country?.name?.toLocaleLowerCase().replace(/\s+/g, '-') || 'country';
  const citySlug = slug?.toLocaleLowerCase().replace(/\s+/g, '-') || 'city';
  const url = `/en/trip/${citySlug}-tourism-${countryName}-${_id}-ctytsmid`;
  const url2 = `/ar/trip/${citySlug}-tourism-${countryName}-${_id}-ctytsmid`;

  return (
    <Link
      to={lang === "ar" ? url2 : url}
      key={key}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="rounded-md text-center cursor-pointer flex-none"
      id="popular-destination-card"
    >
      <div id="popular-destination-card-image">
        <img
          src={image || 'fallback-image-url.jpg'}
          alt={name || 'Default Name'}
          className="rounded-xl lg:w-[276px] lg:h-[350px] max-sm:w-[200px] max-sm:h-[260px]"
        />
      </div>

      <div className="relative text-center bottom-[60px] max-sm:bottom-[45px]" id="popular-destination-card-text">
        <p className="text-white font-bold max-sm:text-[20px] lg:text-[30px]">
          {lang === "ar" ? ar_name || 'Default Arabic Name' : name || 'Default Name'}
        </p>
        <p className="text-white max-sm:mt-1 max-sm:text-[14px] lg:mt-1">
          <PlaceIcon sx={{ fontSize: "14px" }} /> {state2?.name || 'State'}
        </p>
      </div>
    </Link>
  );
}

export default PopularCityCard;
